import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    divider: {
        margin: theme.spacing(2, 0),
        backgroundColor: theme.palette.grey[300],
    },
    form: {
        marginBottom: theme.spacing(3),
    },
}))